import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@mui/material';
import NoteDetail from './note_detail';
import { useUpdateNoteMutation } from '../../app/smorgAppSyncGraphQLApi';
import { noteWithSectionUpdated } from '../../services/notes';
import { useGetNoteByIDAndParentQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const NoteDetailContainer = ({
  parentSmorgBoardId,
  noteId,
  visible,
  dismiss,
}) => {
  // Must not access state from within callbacks passed to ContentEditable.
  // The issue is described at:
  // https://github.com/lovasoa/react-contenteditable/issues/161
  // We no longer use ContentEditable so this can be removed.
  const currentTextRef = useRef();
  const currentNoteRef = useRef();

  const [currentlyEditingInline, setCurrentlyEditingInline] = useState({
    section: null,
    itemId: null,
  });

  const { data: note } = useGetNoteByIDAndParentQuery(
    { id: noteId, parentID: parentSmorgBoardId },
    { skip: !noteId || !parentSmorgBoardId },
  );

  const [updateNote] = useUpdateNoteMutation();

  useEffect(() => {
    currentNoteRef.current = note;
  }, [note]);

  const dismissEditingInline = () => {
    currentTextRef.current = null;
    setCurrentlyEditingInline({ section: null, itemId: null });
  };

  if (!visible || !note) {
    return null;
  }

  console.log(`NoteDetail noteId=${noteId}`);

  const onInlineEditBlur = async (section, itemId, reason) => {
    console.log(`Blur ${section} ${itemId} ${reason}`);
    if (['title', 'description'].includes(section)) {
      const contentChanged =
        currentTextRef.current !== currentNoteRef.current[section];
      if (contentChanged) {
        const newContent = currentTextRef.current;
        if (section === 'description' && !newContent) {
          console.warn('newContent is blank! doing nothing.');
        } else {
          const updatedNote = noteWithSectionUpdated(note, section, newContent);
          await updateNote(updatedNote);
        }
      }
    }

    dismissEditingInline();
  };

  const onInlineEditFocus = (section) => {
    console.log(`Focus ${section}`);
    const value = currentNoteRef.current[section] || '';
    currentTextRef.current = value.toString();
    setCurrentlyEditingInline({ section });
  };

  const onInlineEditChange = (section, itemId, value) => {
    console.log(`Change ${section}`);
    currentTextRef.current = value;
  };

  const onDialogClose = (ev, reason) => {
    if (reason === 'escapeKeyDown') {
      console.log('Dialog escape key down');
      // Prevent dialog from closing, let the contenteditable handle the esc key
      return null;
    }
    console.log(`Dialog close other reason: ${reason}`);
    dismiss();
    return true;
  };

  return (
    <Dialog
      open
      maxWidth="sm"
      fullWidth
      // For TinyMCE
      disableEnforceFocus
      onClose={onDialogClose}>
      <NoteDetail
        note={note}
        currentlyEditingInline={currentlyEditingInline}
        onInlineEditFocus={onInlineEditFocus}
        onInlineEditChange={onInlineEditChange}
        onInlineEditBlur={onInlineEditBlur}
        onDialogClose={onDialogClose}
      />
    </Dialog>
  );
};

NoteDetailContainer.propTypes = {
  parentSmorgBoardId: PropTypes.string,
  noteId: PropTypes.string,
  visible: PropTypes.bool.isRequired,
  dismiss: PropTypes.func,
};

NoteDetailContainer.defaultProps = {
  parentSmorgBoardId: null,
  noteId: null,
  dismiss: () => {},
};

export default NoteDetailContainer;
